export const termsTranslations = {
  title: 'Terms and Conditions',
  lastUpdated: 'Last Updated: March 7, 2024',
  sections: {
    introduction: {
      title: 'Introduction',
      content:
        'Welcome to BiteCritic! These Terms and Conditions govern your use of our platform and services. By using BiteCritic, you agree to these terms in full.',
    },
    userAgreement: {
      title: 'User Agreement',
      content: 'By creating an account on BiteCritic, you agree to:',
      items: [
        'Provide accurate and truthful information',
        'Maintain the security of your account',
        'Take responsibility for all activities under your account',
        'Comply with all applicable laws and regulations',
      ],
    },
    content: {
      title: 'Content Guidelines',
      content: 'When using BiteCritic, you agree to:',
      items: [
        'Share authentic and honest reviews',
        'Respect intellectual property rights',
        'Not post harmful, offensive, or inappropriate content',
        'Not engage in spam or misleading behavior',
      ],
    },
    contentRights: {
      title: 'Content Rights and Retention',
      content: 'Regarding your content on BiteCritic:',
      items: [
        'You retain ownership of your content, but grant us a worldwide, non-exclusive, royalty-free license to use, display, distribute, reproduce, modify, and create derivative works of your content in connection with the Service and for BiteCritic\'s promotional and marketing purposes, including but not limited to display on our website, app, and third-party platforms such as social media',
        'When you delete your account, your personal information will be anonymized, but your reviews and other contributed content may be retained',
        'Content will appear as posted by "Anonymous User" after account deletion',
        'For complete deletion of all content, you must contact us directly at hurricanesoftwaresolutions@gmail.com',
        'We may continue to display anonymized reviews to preserve the value of the platform for all users',
      ],
    },
    privacy: {
      title: 'Privacy and Data',
      content:
        'We take your privacy seriously. By using BiteCritic, you acknowledge that:',
      items: [
        'We collect and process your data as described in our Privacy Policy',
        'Your public profile and reviews are visible to other users',
        'You can control your privacy settings through your account',
        'We use cookies and similar technologies',
      ],
    },
    community: {
      title: 'Community Guidelines',
      content: 'As a member of the BiteCritic community, you agree to:',
      items: [
        'Treat other users with respect',
        'Not harass or discriminate against others',
        'Provide constructive and helpful contributions',
        'Report inappropriate content or behavior',
      ],
    },
    termination: {
      title: 'Account Termination',
      content: 'We reserve the right to:',
      items: [
        'Suspend or terminate accounts that violate these terms',
        'Remove content that violates our guidelines',
        'Modify or discontinue services with reasonable notice',
        'Anonymize user data but retain content upon account deletion',
        'Process complete deletion requests submitted via email within 30 days',
      ],
    },
  },
  agreement: {
    checkbox: 'I have read and agree to the Terms and Conditions',
    required: 'You must agree to the Terms and Conditions to continue',
    view: 'View Terms and Conditions',
  },
} as const;

export type TermsTranslations = {
  title: string;
  lastUpdated: string;
  sections: {
    introduction: {
      title: string;
      content: string;
    };
    userAgreement: {
      title: string;
      content: string;
      items: string[];
    };
    content: {
      title: string;
      content: string;
      items: string[];
    };
    contentRights: {
      title: string;
      content: string;
      items: string[];
    };
    privacy: {
      title: string;
      content: string;
      items: string[];
    };
    community: {
      title: string;
      content: string;
      items: string[];
    };
    termination: {
      title: string;
      content: string;
      items: string[];
    };
  };
  agreement: {
    checkbox: string;
    required: string;
    view: string;
  };
};

export default termsTranslations;
